import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import { store } from './app/store';
import { Provider } from 'react-redux';
import './app/localization/localization';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './apis/api.config';
import * as Sentry from '@sentry/react';

const hostname = window.location.hostname;

let environment = 'unknown';
let shouldInitSentry = true;

if (hostname === 'localhost' || hostname === '127.0.0.1') {
  environment = 'local';
  shouldInitSentry = false; // don't send events from localhost
} else if (hostname === 'dev-admin.raqt.com') {
  environment = 'dev';
} else if (hostname === 'admin.raqt.com') {
  environment = 'production';
} else {
  environment = 'other';
}

const DSN = process.env.REACT_APP_SENTRY_DSN;

if (shouldInitSentry && DSN) {
  Sentry.init({
    dsn: DSN,
    environment,
    sendDefaultPii: false,
    // tracesSampleRate: 0.2,
    // integrations: [Sentry.browserTracingIntegration()],
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </Provider>
);
